import { observable, toJS, flow, action } from "mobx";
import {
	getContentGroups,
	createContentGroup,
	renameContentGroup,
	deleteContentGroups
} from "services/contentgroups";
import { registerHandler, delay } from "services/api";
import { message } from "antd";
import _ from "lodash";

export default class ContentGroupsStore {
	// constructor() {
	//     this.contentGroups = observable.array([]);
	//     this.ui = this.getUI();
	// }
	constructor() {
		this.contentGroups = observable.array([]);
		this.ui = this.getUI();
	}

	getUI = () => {
		let ui = {
			loadingContentGroups: false,
			addEditContentGroupDialogVisible: false,
			editedContentGroup: null, //When editedContentGroup is not null, it means that we are editing that content group
			renamingContentGroup: false,
			deletingContentGroups: false,
			creatingContentGroup: false
		};
		return observable.object(ui);
	};

	@action
	showAddContentGroupDialog = () => {
		this.ui.addEditContentGroupDialogVisible = true;
		this.ui.editedContentGroup = null;
	};

	@action
	hideAddEditContentGroupDialog = () => {
		this.ui.addEditContentGroupDialogVisible = false;
		this.ui.editedContentGroup = null;
	};

	@action
	showEditContentGroupDialog = contentGroup => {
		this.ui.addEditContentGroupDialogVisible = true;
		this.ui.editedContentGroup = contentGroup;
	};

	@action
	hideEditContentGroupDialog = () => {
		this.ui.addEditContentGroupDialogVisible = false;
		this.ui.editedContentGroup = null;
	};

	createContentGroup = flow(function*(name) {
		this.ui.creatingContentGroup = true;
		const response = yield createContentGroup(name);
		this.ui.creatingContentGroup = false;

		if (response == null) {
			message.error("Failed to create new content group. Unknown error", 3);
			return;
		}

		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully created a new content group", 3);
		this.ui.addEditContentGroupDialogVisible = false;
		this.ui.editedContentGroup = null;
	});

	remoteRenameContentGroup = flow(function*(contentGroup) {
		this.ui.renamingContentGroup = true;
		const response = yield renameContentGroup(contentGroup);
		this.ui.renamingContentGroup = false;
		if (response == null) {
			message.error("Failed to rename the content group. Unknown error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully rename the content group", 3);
		this.ui.addEditContentGroupDialogVisible = false;
		this.ui.editedContentGroup = null;
	});

	@action
	renameContentGroup = contentGroup => {
		const foundIndex = this.contentGroups.findIndex(el => {
			return el.id == contentGroup.id;
		});

		if (foundIndex != -1) {
			this.contentGroups[foundIndex].name = contentGroup.name;
		}
	};

	remoteDeleteContentGroups = flow(function*(ids) {
		this.ui.deletingContentGroups = true;
		const response = yield deleteContentGroups(ids);
		this.ui.deletingContentGroups = false;
		if (response == null) {
			message.error("Failed to delete selected content group. Unknown error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully deleted selected content group", 3);
	});

	@action
	deleteContentGroups = ids => {
		_.remove(this.contentGroups, contentGroup => {
			return ids.includes(contentGroup.id);
		});
	};

	@action
	addContentGroup = contentGroup => {
		this.contentGroups.push(contentGroup);
	};

	loadContentGroups = flow(function*() {
		this.ui = this.getUI();
		this.ui.loadingContentGroups = true;
		const response = yield getContentGroups();
		this.ui.loadingContentGroups = false;
		if (response == null) {
			message.error("Failed to load content groups. Unexpected error", 3);
			return;
		}
		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}
		this.contentGroups = observable.array(response.content_groups);

		registerHandler([
			{
				path: "content_groups",
				handler: (err, msg) => {
					if (err != null) return;
					const obj = JSON.parse(msg.body);
					if (obj.action == "newContentGroup") {
                        var contentGroup = obj.contentGroup;
                        // console.log(contentGroup);
						this.addContentGroup(contentGroup);
						return;
					}

					if (obj.action == "contentGroupEdited") {
						this.renameContentGroup({
							name: obj.name,
							id: obj.contentGroupId,
							count: obj.count
						});
						return;
					}

					if (obj.action == "contentGroupsDeleted") {
	                    //Delete by Id
						this.deleteContentGroups(obj.contentGroups);
						return;
					}
				}
			}
		]);
	});
}
